import React, { useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { useLang } from '../i18n'

export function ResetPasswordPage() {
  const { t } = useLang()
  const navigate = useNavigate()
  const [params] = useSearchParams()
  const token = params.get('token') || ''
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [done, setDone] = useState(false)

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    if (password !== confirm) {
      setError(t('errorPasswordMismatch'))
      return
    }
    if (!password.trim()) {
      setError(t('errorPasswordEmpty'))
      return
    }
    setLoading(true)
    try {
      const r = await fetch('/api/auth/reset', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      })
      if (r.ok) {
        setDone(true)
        setTimeout(() => navigate('/login', { replace: true }), 2000)
      } else {
        const err = await r.json()
        setError(err?.error?.message || t('errorGeneric'))
      }
    } catch {
      setError(t('errorGeneric'))
    } finally {
      setLoading(false)
    }
  }

  if (!token) {
    return (
      <div style={{ textAlign: 'center', marginTop: '48px' }}>
        <p style={{ color: 'var(--danger)' }}>{t('errorInvalidResetLink')}</p>
        <Link to="/login">{t('backToLogin')}</Link>
      </div>
    )
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
      <div style={{
        width: '340px', padding: '32px', border: '1px solid var(--border)',
        borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.08)', background: 'var(--bg-surface)',
      }}>
        <h2 style={{ margin: '0 0 24px 0', fontSize: '20px', color: 'var(--text-primary)', textAlign: 'center' }}>
          {t('resetPasswordTitle')}
        </h2>

        {done ? (
          <p style={{ color: 'var(--success)', fontSize: '14px' }}>{t('resetPasswordSuccess')}</p>
        ) : (
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {error && (
              <div style={{
                padding: '10px 12px', background: 'var(--danger-bg)', border: '1px solid var(--danger)',
                borderRadius: '4px', color: 'var(--danger)', fontSize: '13px',
              }}>
                {error}
              </div>
            )}

            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <label style={{ fontSize: '13px', color: 'var(--text-secondary)' }}>{t('newPassword')}</label>
              <input
                type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
                style={{ padding: '8px 10px', border: '1px solid var(--border)', borderRadius: '4px', fontSize: '14px' }}
              />
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
              <label style={{ fontSize: '13px', color: 'var(--text-secondary)' }}>{t('confirmPassword')}</label>
              <input
                type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required
                style={{ padding: '8px 10px', border: '1px solid var(--border)', borderRadius: '4px', fontSize: '14px' }}
              />
            </div>

            <button type="submit" disabled={loading} style={{
              padding: '10px', background: loading ? 'var(--text-muted)' : 'var(--accent)',
              color: 'var(--accent-contrast)', border: 'none', borderRadius: '4px', fontSize: '14px',
              fontWeight: 600, cursor: loading ? 'not-allowed' : 'pointer',
            }}>
              {loading ? t('loading') : t('resetPasswordSubmit')}
            </button>
          </form>
        )}
      </div>
    </div>
  )
}
